import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { createExtraWorkCategory } from '../../../apiMethod/extraWorkCategories.js';

export default function AddExtraWorkCategory({ show, onHide, jwt, onCreated }) {
    const [name, setName] = useState('');
    const [pcefProcent, setPcefProcent] = useState(0);
    const [salary, setSalary] = useState(0);

    const onSubmit = async () => {
        const response = await createExtraWorkCategory(jwt, name, pcefProcent, salary);
        if (response) {
            onCreated(response);
            onHide();
        } else alert('Не удалось создать');
    };

    return (
        <Modal centered show={show} onHide={onHide}>
            <Form onSubmit={e => e.preventDefault() || onSubmit()}>
                <Modal.Header closeButton>
                    <Modal.Title>Новая категория</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Название</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Процент ПКЭФ</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            value={pcefProcent}
                            onChange={(e) => setPcefProcent(parseInt(e.target.value) || 0)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Оклад</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            step="1"
                            value={salary}
                            onChange={(e) => setSalary(parseFloat(e.target.value) || 0)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>Закрыть</Button>
                    <Button variant="success" type="submit">Создать</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}